import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { LoadingSpinner } from "@vfit/shared/atoms";
import WithHeader from "../WithHeader/WithHeader";
import WithSeeMore from "../WithSeeMore/WithSeeMore";
import { VideoStyled } from "./Video.style";
var Video = function(param) {
    var story = param.story, action = param.action, isPaused = param.isPaused, config = param.config, messageHandler = param.messageHandler;
    var vid = useRef(null);
    var ref = useState(false), loaded = ref[0], setLoaded = ref[1];
    var ref1 = useState(false), muted = ref1[0], setMuted = ref1[1];
    var width = config.width, height = config.height, loader = config.loader;
    useEffect(function() {
        setLoaded(false);
    }, [
        story
    ]);
    useEffect(function() {
        if (vid.current) {
            if (isPaused) {
                vid.current.pause();
            } else {
                vid.current.play().catch(function() {});
            }
        }
    }, [
        isPaused
    ]);
    useEffect(function() {
        if (loaded) {
            if (vid === null || vid === void 0 ? void 0 : vid.current) {
                vid.current.play().then(function() {
                    action("play");
                }).catch(function() {
                    var ref;
                    setMuted(true);
                    vid === null || vid === void 0 ? void 0 : (ref = vid.current) === null || ref === void 0 ? void 0 : ref.play().finally(function() {
                        action("play");
                    });
                });
            }
        }
    }, [
        loaded
    ]);
    var onWaiting = function() {
        action("pause", true);
    };
    var onPlaying = function() {
        action("play", true);
    };
    var videoLoaded = function() {
        var ref;
        messageHandler("UPDATE_VIDEO_DURATION", {
            duration: vid === null || vid === void 0 ? void 0 : (ref = vid.current) === null || ref === void 0 ? void 0 : ref.duration
        });
        setLoaded(true);
    };
    return /*#__PURE__*/ _jsx(WithHeader, {
        story: story,
        children: /*#__PURE__*/ _jsx(WithSeeMore, {
            story: story,
            children: /*#__PURE__*/ _jsxs(VideoStyled, {
                className: "videoContainer",
                children: [
                    /*#__PURE__*/ _jsx("video", {
                        ref: vid,
                        src: story.url,
                        controls: false,
                        onLoadedData: videoLoaded,
                        playsInline: true,
                        onWaiting: onWaiting,
                        onPlaying: onPlaying,
                        muted: muted,
                        autoPlay: true
                    }),
                    !loaded && /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: width,
                            height: height,
                            position: "absolute",
                            left: 0,
                            top: 0,
                            background: "rgba(0, 0, 0, 0.9)",
                            zIndex: 9,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#ccc"
                        },
                        children: loader || /*#__PURE__*/ _jsx(LoadingSpinner, {})
                    })
                ]
            })
        })
    });
};
export var tester = function(story) {
    return {
        condition: story.type === "video",
        priority: 2
    };
};
export default {
    renderer: Video,
    tester: tester
};
